import posthog from 'posthog-js';

let _initialized = false;
const isDevelopment = process.env.NODE_ENV === 'development';

export function initPostHog() {
  if (_initialized) return posthog;

  // PostHog surveys/widgets are causing DOM teardown errors during local
  // route transitions in development, so keep analytics disabled there.
  if (isDevelopment) {
    _initialized = true;
    return posthog;
  }

  posthog.init('phc_whvLE3dPiVVdLboqjHZCbJLEtwkzXJQdTBwwfFcJJnvK', {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    capture_pageview: false, // React Router handles pageviews (avoid duplicates)
    disable_surveys: true,
  });

  _initialized = true;
  return posthog;
}

export function identifyPostHogUser(user) {
  if (isDevelopment) return;
  if (!user) return;

  const distinctId = user.id ?? user.userId ?? user._id ?? user.email;
  if (!distinctId) return;

  const props = {
    email: user.email,
    name: user.name ?? user.fullName,
    role: user?.role?.value ?? user?.role,
  };

  posthog.identify(String(distinctId), props);
}

export function resetPostHogUser() {
  if (isDevelopment) return;
  posthog.reset();
}

export default posthog;
